import styled from 'styled-components';

export const Container = styled.div`
  .submit-kyc {
    display: none;
    visibility: hidden;
    opacity: 0;
  }
`;
